import { NgModule } from '@angular/core';
import { TableModule } from '../table/table.module';
import { CdkTableModule } from '@angular/cdk/table';
import { MobxAngularModule } from 'mobx-angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TooltipModule } from 'ng2-tooltip-directive';
import { PendingPostsManagerComponent } from './pending-posts-manager/pending-posts-manager.component';
import { PerformanceChartComponent } from './performance-chart/performance-chart.component';
import { LeaderboardListComponent } from './leaderboard-list/leaderboard-list.component';
import { NetsocialInsightsComponent } from './netsocial-insights/netsocial-insights.component';
import { SharedComponentsModule as PSharedCompMod } from 'netsocial-posting/src/app/components/shared-components/shared-components.module';
import { UserRankComponent } from './user-rank/user-rank.component';
import { LeaderboardViewerComponent } from './leaderboard-viewer/leaderboard-viewer.component';
import { LeaderboardCardComponent } from './leaderboard-card/leaderboard-card.component';
import { PerformanceGridComponent } from './performance-grid/performance-grid.component';
import { JoyrideModule } from 'ngx-joyride';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';
import { SharedComponentsModule } from '../shared-components/shared-components.module';

const components = [
  PendingPostsManagerComponent,
  PerformanceChartComponent,
  LeaderboardListComponent,
  NetsocialInsightsComponent,
  UserRankComponent,
  LeaderboardViewerComponent,
  LeaderboardCardComponent,
  PerformanceGridComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    MobxAngularModule,
    TableModule,
    CdkTableModule,
    TooltipModule,
    PSharedCompMod,
    NgxChartsModule,
    JoyrideModule.forChild(),
    RouterModule,
    SharedComponentsModule,
  ],
  exports: [...components],
})
export class DashboardModule {}
